<div class="modal-container">

    <div class="modal-header modal-book modal-head-brb-pad d-inline-block">
      <div class="justify-content-between">
        <div class="filter-body">
          <h4 class="modal-title text-body">Filter</h4>
          <button class="modal-clost-btn" (click)="bsModalRef?.hide()" aria-label="Close">&times;</button>
          <form >
              <div>
                <p class="modal-text my-3">Property Type</p>
              
              </div>
              
              <div class="row" >
                  <div class="col-md-6 col-6 mb-2" *ngFor="let type of propertyTypeList; let f = index">
                      <app-checkbox
                      [name]="type.name"
                      [value]="type.label"
                      [label]="type.label"
                      [model]="type.checked"
                      (clicked)="getPropertyType($event, f)"
                      ></app-checkbox>
                    </div>
                </div>
                <div class="border-top"></div>
              <div>
                <p class="modal-text my-3">Rooms & Guests</p>
              
              </div>

              <div class="row">
                  <div class="col-md-4 col-6">
                      <label class="form-label">Beds</label>
                      <app-input [formGrp]="bedForm" formCtrlName="bed" [value]="bedForm.value.bed"   number></app-input>
          
                  </div>
                  <div class="col-md-4 col-6">
                      <label class="form-label">Bathrooms</label>
                      <app-input [formGrp]="bathroomForm" formCtrlName="bathroom"  [value]="bathroomForm.value.bathroom"  number></app-input>
          
                  </div>
                  <div class="col-md-4 col-6">
                      <label class="form-label">Guests</label>
                      <app-input [formGrp]="guestForm" formCtrlName="guest" [value]="guestForm.value.guest" number></app-input>
          
                  </div>
              </div>
              <div class="border-top"></div>
              <div>
                  <p class="modal-text my-3">Home Faciltites</p>
                  <div class="row" >
                      <div class="col-md-6 col-6 mb-2" *ngFor="let facility of propertyFaciliies; let f = index">
                        <app-checkbox
                        [name]="facility.name"
                        [value]="facility.label"
                        [label]="facility.label"
                        [model]="facility.checked"
                        (clicked)="getFacilities($event, f)"
                         ></app-checkbox>
                      </div>
                    </div>
              </div>
              <div class="border-top"></div>
              <div>
                  <p class="modal-text my-3">Extra Features</p>
                  <div class="row">
                      <div class="col-md-6 col-6 mb-2" *ngFor="let extra of extraFeatures; let e = index">
                        <app-checkbox
                        [name]="extra.name"
                        [value]="extra.label"
                        [label]="extra.label"
                        [model]="extra.checked"
                        (clicked)="getExtras($event, e)"
                         ></app-checkbox>
                      </div>
                    </div>
              </div>
              <div class="border-top"></div>
              <div>
                  <p class="modal-text my-3">Home Rules</p>
                  <div class="row">
                      <div class="col-md-6 col-6 mb-2" *ngFor="let rules of homeRules; let r = index ">
                          <app-checkbox
                          [name]="rules.name"
                          [value]="rules.label"
                          [label]="rules.label"
                          [model]="rules.checked"
                          (clicked)="setHomeRules($event, r)"
                           ></app-checkbox>
                        </div>
          
                  </div>
              </div>
              <div class="border-top"></div>
              <div>
                  <p class="modal-text my-3">Health & Safety</p>
                  <div class="row">
                      <div class="col-md-6 col-6 mb-2" *ngFor="let health of healthAlarm; let h = index ">
                          <app-checkbox
                          [name]="health.name"
                          [value]="health.name"
                          [label]="health.label"
                          [model]="health.checked"
                          (clicked)="setSafety($event, h)"
                           ></app-checkbox>
                        </div>
          
                  </div>
              </div>
              <div class="border-top"></div>
              <div>
                  <p class="modal-text my-3">Distance Away(Miles)</p>
                  <div class="row">
                      <div class="col-md-12"  >
                          <app-custom-radio #radiusElement [options]="distance" (changed)="setDistance($event)"></app-custom-radio>
          
                      </div>
          
          
                  </div>
              </div>
              <!-- <div class="border-top"></div>
              <div class="d-flex justify-content-between align-items-center">
                  <p class="modal-text my-3">Instant Booking </p>
                  <app-toggle  [isSwitch]="true" [label]="''" ></app-toggle>
                  
              </div> -->
          </form>
        </div>
  
        
        <div class="d-flex justify-content-between align-items-center actions">
          <a  class="title" type="button" (click)="resetFilters()">Reset Filters</a>
          <app-button warning (onclick)="closeModal()">Show Properties</app-button>
        </div>
      </div>
  
  
    </div>
  
  </div>
  